<template>
    <div class="auth">
        <div class="auth__pic"></div>
        <div class="auth__title">
            {{getUserEmail}}
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        computed: {
            ...mapGetters([
                'getUserEmail'
            ]),
        }
    }
</script>

<style lang="sass" scoped>
    .auth
        display: flex
        justify-content: center
        align-items: center
        &__pic
            display: flex
            align-items: center
            justify-content: center

        &__title
            font-size: 16px
            line-height: 24px
            color: $color--dark
            +medium
            padding-left: 30px
            position: relative
            +text-overflow
            max-width: 240px
            &:before
                content: ''
                z-index: 1
                display: block
                position: absolute
                top: 50%
                left: 0
                transform: translateY(-50%)
                background-image: url('~@/assets/img/auth/auth.svg')
                +cover
                width: 17px
                height: 20px

</style>